import { ChangeDetectionStrategy, Component, inject, input, output} from '@angular/core';
import { AbstractComponent } from '@spike/scaffolds';
import { TableModule } from 'primeng/table';
import { Tag } from "primeng/tag";
import { EtiquetteApiEnum } from 'src/app/config/entity-api.enum';
import { EtiquetteDecoderPipe } from 'src/app/features/configuration/pipes/etiquette-decoder.pipe';
import { LeftPadPipe } from 'src/app/features/shared/pipes/left-pad.pipe';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-organizations-table',
  providers:[],
  imports: [TableModule, LeftPadPipe, Tag, EtiquetteDecoderPipe],
  templateUrl: './organizations-table.html'
})

export class OrganizationsTableComponent extends AbstractComponent{
    items = input.required<any[]>();
    entityKey = input.required<string>();
    etiquetteApi = input.required<EtiquetteApiEnum>();
    onSelect = output<any>();

}
  

